import { useState } from 'react';

import { useUser } from './use_user';

export const useNavBarFavorites = () => {
  const user = useUser();
  return useState(() => new Set(user.admin_nav_favorites));
};
